'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroups$002dView$0024$0024anon$002443 from "./presto.-Groups-View$$anon$43.js";
import * as $j_presto$002e$002dGroups$002dView$0024$0024anon$002444 from "./presto.-Groups-View$$anon$44.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$42(outer) {
  this.aYI = null;
  this.aYG = null;
  this.aYH = false;
  this.aYE = null;
  this.aYF = false;
  this.aYJ = false;
  this.aYK = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aYI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_GroupsView$$anon$42 as $c_Lpresto_GroupsView$$anon$42 };
$p = $c_Lpresto_GroupsView$$anon$42.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$42;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$42() {
}
export { $h_Lpresto_GroupsView$$anon$42 as $h_Lpresto_GroupsView$$anon$42 };
$h_Lpresto_GroupsView$$anon$42.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aYI;
});
$p.t = (function() {
  if ((!this.aYH)) {
    this.aYG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ByCredentialAndDocumentType", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aYH = true;
  }
  return this.aYG;
});
$p.ae = (function() {
  if ((!this.aYF)) {
    this.aYE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dGroups$002dView$0024$0024anon$002443.$c_Lpresto_GroupsView$$anon$43(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aYF = true;
  }
  return this.aYE;
});
$p.w = (function() {
  if ((!this.aYK)) {
    this.aYJ = true;
    this.aYK = true;
  }
  return this.aYJ;
});
$p.cDZ = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeSum__I__O__Lio_circe_JsonObject(this, new $j_presto$002e$002dGroups$002dView$0024$0024anon$002444.$c_Lpresto_GroupsView$$anon$44().cMG(a), a);
});
$p.ac = (function(a) {
  return this.cDZ(a);
});
var $d_Lpresto_GroupsView$$anon$42 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$42, "presto.GroupsView$$anon$42", ({
  JX: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_GroupsView$$anon$42 as $d_Lpresto_GroupsView$$anon$42 };
//# sourceMappingURL=presto.-Groups-View$$anon$42.js.map
